@let portalOrder = portalOrder$ | async; @let state = stateService.getState();
@if (portalOrder) {
  <stepper
    [step]="Steps.ProtectionPlans"
    [isChangeMode]="portalOrder.isChange"
    [ancillaryUpsell]="ancillaryUpsell"
  />

  @let discount = (portalOrder.ancillaryBundle?.discount || 0) * 100;

  <div class="d-flex flex-column flex-md-row p-4 p-md-0 py-md-6">
    <div class="d-flex flex-column flex-1">
      <h2 class="semi-bold">Cancel your trip — and still get your money back</h2>

      <p class="mt-2">
        With Cancel For Any Reason, you can cancel up to 48 hours before departure and get up to 80%
        cash back or 100% as travel credit
      </p>

      @if (state.disruptionProtection) {
        <ds-card class="d-flex flex-column p-4 mt-4 card text-purple-700 favorite">
          <div class="d-flex align-items-center">
            <img src="/assets/icons/favorite.svg" alt="favorite" width="20" height="20" />

            <p class="ml-1 semi-bold">Travelers' favorite</p>
          </div>

          <h3 class="semi-bold mt-1">
            Add Cancel For Any Reason now — save {{ discount }}% as part of your protection bundle
          </h3>

          <p class="mt-1">Includes Cancel For Any Reason + Premium Disruption Assistance</p>
        </ds-card>
      }

      <ds-card class="d-flex flex-column p-4 p-md-6 mt-4 card">
        <div class="d-flex align-items-center">
          <img
            src="/assets/images/3d-calendar-white.webp"
            alt="3d-calendar-white"
            width="120"
            height="120"
          />

          <div class="d-flex flex-column ml-md-6">
            <h2 class="semi-bold">Cancel For Any Reason</h2>

            @if (state.disruptionProtection || state.bundle) {
              <div class="d-flex align-items-center mt-1">
                <p class="text-purple-700">Bundle price</p>
                <p class="semi-bold ml-2 discount">-{{ discount }}%</p>
              </div>

              <p class="semi-bold" data-id="price-per-traveler">
                {{ pricePerTraveler | portalCurrency }}
                <del>{{ priceWithoutDiscountPerTraveler | portalCurrency }}</del> per person
              </p>
            } @else {
              <p class="semi-bold mt-1" data-id="price-per-traveler">
                {{ priceWithoutDiscountPerTraveler | portalCurrency }} per person
              </p>
            }
          </div>
        </div>

        <hr class="my-6" />

        <div class="d-flex flex-column g-6 flex-md-row">
          @for (section of sections; track section) {
            <div class="d-flex flex-1 flex-column g-3">
              <p class="semi-bold">{{ section.title }}</p>

              @for (item of section.items; track item) {
                <div class="item">
                  <img
                    src="/assets/icons/{{ item.icon }}.svg"
                    alt="{{ item.icon }}"
                    width="20"
                    height="20"
                  />

                  <p class="semi-bold">{{ item.label }}</p>

                  <p>&nbsp;</p>

                  <p>{{ item.details }}</p>
                </div>
              }
            </div>
          }
        </div>
      </ds-card>

      <div class="d-none d-md-flex flex-md-row-reverse g-2 mt-6">
        <ng-container *ngTemplateOutlet="actionsTemplate" />
      </div>
    </div>

    <div class="d-flex flex-column g-6 mt-8 mt-md-0 ml-md-5">
      <price-summary
        [option]="portalOrder"
        [disruptionProtection]="state.disruptionProtection"
        [tipsAmount]="state.tipsAmount"
        [bundle]="state.bundle"
        [cancelForAnyReason]="state.cancelForAnyReason"
        [promocodeDiscountAmount]="state.promocodeDiscountAmount"
      />

      <client-review
        [data]="{
          review:
            'This was the second time that I have consulted Lisa for help with my travel.  Unfortunately, I needed to cancel my trip.  Fortunately, I took advantage of the cancel for any reason insurance. Lisa made it very easy to accomplish the task.  I can`t say enough about both Lisa and Tiffany for their help with my travel needs.',
          from: 'Greg Hopkins',
          img: '/assets/images/client_d.webp',
          details: 'Apr 30, 2025',
        }"
        class="review"
      />
    </div>

    <div class="d-flex flex-column g-2 mt-8 d-md-none">
      <ng-container *ngTemplateOutlet="actionsTemplate" />
    </div>
  </div>
}

<ng-template #actionsTemplate>
  <ds-button (click)="continue()" data-id="continue" label="Continue with protection" />

  <ds-button
    (click)="next()"
    variant="secondary"
    class="ml-md-auto"
    data-id="no"
    label="Continue without protection"
  />

  <ds-button
    (click)="back()"
    variant="secondary"
    leadingIcon="chevronLeft"
    data-id="back"
    label="Back"
  />
</ng-template>

<ng-template #disruptionProtectionModalTemplate>
  <disruption-protection-modal
    (upsellDisruptionProtectionContinue)="upsellDisruptionProtectionContinue()"
    (upsellDisruptionProtectionNext)="upsellDisruptionProtectionNext()"
    (hideModal)="hideModal()"
    [disruptionProtectionAncillary]="disruptionProtectionAncillary"
    [ancillaryBundle]="this.portalOrder?.ancillaryBundle"
  />
</ng-template>

<ng-template #ancillariesBundleModalTemplate>
  <ancillaries-bundle-modal
    (ancillariesBundleContinue)="ancillariesBundleContinue()"
    (ancillariesBundleNext)="ancillariesBundleNext()"
    (hideModal)="hideModal()"
    [ancillaryBundle]="this.portalOrder?.ancillaryBundle"
  />
</ng-template>

<ng-template #askToSignInTemplate>
  <ask-to-sign-in-modal
    (hideModal)="hideAskToSignInModal()"
    (continueAsGuest)="continueAsGuestFromSignInPrompt()"
    (showSignInModal)="showSignInModal()"
  />
</ng-template>
